import { z } from 'zod'

import { apiValueSchema, periodResponseSchema, valueStatusSchema } from './common'

/** Бакет входов — internal_api.VisitorBucketResponse; entered есть только при ok, неизмеренный бакет — no_data, а не 0. */
export const visitorBucketSchema = z.object({
  interval_start: z.string(),
  status: valueStatusSchema,
  entered: z.number().nullable().optional(),
})
export type VisitorBucket = z.infer<typeof visitorBucketSchema>

/**
 * GET /visitors?period|from&to — internal_api.VisitorsResponse (ТЗ п. 5.3, 5.5): входы посетителей
 * по всем камерам, бакеты плотные по шагу period.bucket_size. total — сумма измеренных бакетов
 * (0 включительно) или no_data, когда не измерено ничего.
 */
export const visitorsSchema = z.object({
  period: periodResponseSchema,
  buckets: z.array(visitorBucketSchema),
  total: apiValueSchema,
})
export type Visitors = z.infer<typeof visitorsSchema>
